/**
 * @file lite文档页页面路由
 * @author Wanzhongyun
 */

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Lite from './Lite';
const DocRoute = () => {
    return (
        <Router>
            <Switch>
                <Route path="/lite" component={Lite} />
            </Switch>
        </Router>
    );
};

export default DocRoute;
